import styled from 'styled-components';
import { math } from 'polished';

const TopNavMenuLink = styled.a`
   font-size: 16px;
   text-decoration: none;
   display: inline-block;
   padding: 0 1em;

   line-height: ${({ theme }) =>
      math(`${theme.sizes.siteHeaderHeight} - 2 * 9px`)};

   color: ${({ theme }) => theme.brandColors.darkGray};
   border-bottom: 9px solid transparent;
   border-top: 9px solid transparent;
   transition: color 0.3s, border-color 0.3s;
   background-color: transparent;
   cursor: pointer;
   outline: none;
   border-right: none;
   border-left: none;
   text-align: left;

   ${({ submenuOpen, theme }) =>
      submenuOpen
         ? `
      color: ${theme.semanticColors.secondary};
      border-bottom-color: ${theme.semanticColors.secondary};
   `
         : ''}

   &:hover,
   &:focus,
   &:active {
      outline: none;
      color: ${({ theme }) => theme.brandColors.lightBlue};
      border-bottom-color: ${({ theme }) => theme.brandColors.lightBlue};
   }

   &::after {
      ${({ hasSubmenu }) => (hasSubmenu ? `content: ''` : '')};
      position: absolute;
      top: 35px;
      right: 2em;
      width: 0;
      height: 0;
      margin-left: 1rem;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 6px solid ${({ theme }) => theme.brandColors.mediumLightGray};
      clear: both;
   }
`;

export { TopNavMenuLink };
